import { FC } from 'react';
import {
  AlertDescription,
  AlertStatus,
  AlertTitle,
  Alert as ChakraAlert,
  AlertProps as ChakraAlertProps,
  Icon,
  IconProps,
  useAlertStyles,
} from '@chakra-ui/react';

import { ErrorIconOutlined, InfoIconOutlined, SuccessIconOutlined, WarningIconOutlined } from './Icons';

export type AlertData = {
  status?: ChakraAlertProps['status'];
  title?: string;
  description?: string;
};

export type AlertProps = ChakraAlertProps & {
  alert?: AlertData;
};

const STATUS_ICON_MAP: Record<AlertStatus, typeof InfoIconOutlined> = {
  success: SuccessIconOutlined,
  warning: WarningIconOutlined,
  error: ErrorIconOutlined,
  info: InfoIconOutlined,
  loading: InfoIconOutlined,
};

const AlertStatusIcon: FC<IconProps & { status?: AlertStatus }> = ({ status = 'info', ...rest }) => {
  const styles = useAlertStyles();
  const StatusIcon = STATUS_ICON_MAP[status] ?? InfoIconOutlined;
  return <Icon as={StatusIcon} __css={styles.icon} {...rest} />;
};

export const Alert: FC<AlertProps> = ({ alert, ...rest }) => {
  return alert ? (
    <ChakraAlert status={alert.status} alignItems="flex-start" {...rest}>
      <AlertStatusIcon status={alert.status} mt="2px" />
      <div>
        {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
        {alert.description && <AlertDescription dangerouslySetInnerHTML={{ __html: alert.description }} />}
      </div>
    </ChakraAlert>
  ) : null;
};
